import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/8/thumb-landscape.jpg"

const Post8 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">PRADA／サフィアーノヴェルニーチェ／25 x17 x10cm</span>
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
          プラダ（PRADA）はイタリアを代表するブランドで、高級感ある三角形のロゴ入りプレートに憧れを抱いている方も少なくはないでしょう。始まりは1913年マリオ・プラダとその弟のフラッテリ・プラダの二人によって開かれた一軒の革製品店でした。上質な素材と高い職人の技術によって作られるアイテムは、イタリアの王室が御用達になったほどです。素材を始め、きちんとした縫製、またブランドの持つ信頼度によって高く評価されています。また、シンプルな色使いや形は飽きが来ず、コーディネートしやすく世界中で幅広い年齢層に愛され続けています。
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>ガレリア</h2>
          <p>プラダで人気の王道である、高品質なサフィアーノレザーを使用した「サフィアーノ」。お仕事女子に人気なのがカチッとしたスタイルにぴったりの「ガレリア」です。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/1.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/2.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">PRADA／ガレリア／27 x20 x11cm</span>       
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/3.jpg" alt="" />
            <span className="text-center">PRADA／ガレリア／28 x20 x11cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/4.jpg" alt="" />
            <span className="text-center">PRADA／サフィアーノ／23 x14 x9cm</span> 
          </figure>
        </div> 
        <div className="text-max-width">
            <h2>カナパ</h2>
            <p>どんなスタイルにもマッチする、人気トート！コットン素材を使用しているため、軽さにも定評がある「カナパ」。ロゴのデザインが大人可愛い、オシャレ好きにはたまらない１点です。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/5.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/6.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">PRADA／カナパ／28 x19 x14cm</span>            
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/7.jpg" alt="" />
            <span className="text-center">PRADA／カナパ／35 x23 x22cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/8.jpg" alt="" />
            <span className="text-center">PRADA／カナパ／35 x24 x22cm</span> 
          </figure>
        </div>     
        <div className="text-max-width">
          <h2>サフィアーノ キュイール</h2>
          <p>女性らしいフォルムに、ゴールドファスナー＆留め具とフロントのロゴメタルプレートが見事にマッチして、リッチな雰囲気を演出します。</p>
        </div>         
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/9.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/10.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">PRADA／サフィアーノキュイール／33 x24 x13cm</span>         
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/11.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/12.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">PRADA／サフィアーノキュイール／33 x25 x14cm</span>       
        <Link to="https://laxus.co/app/pc/bags/prada" className="view-all-button">
          プラダのバッグを見る
        </Link>         
        <div className="text-max-width">
          <h2>ナイロンバッグ</h2>
          <p>ナイロン素材のバッグでも、プラダならハンドル部分やショルダーベルトにレザーを使用しているため、高級感ある雰囲気が楽しめます。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/13.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/14.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">PRADA／リボンハンドバッグ／28 x23 x16cm</span>           
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/15.jpg" alt="" />
            <span className="text-center">PRADA／ショルダーバッグ／24 x18 x5cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/16.jpg" alt="" />
            <span className="text-center">PRADA／テスートボンバー／27 x21 x16cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
        <h2>チェーンショルダー</h2>
          <p>パーティーやちょっとしたお出かけに使いやすくて、コーデを華やかに演出してくれるチェーンショルダー。エレガントコーデを楽しめます。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/17.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/18.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">PRADA／サフィアーノチェーンウォレット／18 x11 x4cm</span>          
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/19.jpg" alt="" />
            <span className="text-center">PRADA／サフィアーノチェーンウォレット／21 x10 x1cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/20.jpg" alt="" />
            <span className="text-center">PRADA／サフィアーノリボンチェーンウォレット／18 x11 x2cm</span> 
          </figure>
        </div>
        <div className="text-max-width">
          <h2>ピオニエール</h2>
          <p>丸みを帯びたフォルムがフェミニンな印象のピオニエール。質感の異なるコンビネーションレザーにブロンズトーンのメタルロゴが映えるシックなデザインです。ちょっとしたお出かけにもぴったりです！</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/8/21.jpg" alt="" />
        </figure>  
        <span className="text-center">PRADA／ピオニエール／19 x15 x6cm</span>           
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/22.jpg" alt="" />
            <span className="text-center">PRADA／ピオニエール／19 x15 x6cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/23.jpg" alt="" />
            <span className="text-center">PRADA／ピオニエール／16 x16 x6cm</span> 
          </figure>
        </div> 
        <div className="text-max-width">
          <h2>エスプラナード</h2>
          <p>サフィアーノとカーフのコンビネーションが楽しめる「エスプラナード」。シックなデザインでシンプルなコーデもオシャレに仕上げてくれます。</p>
        </div>         
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/24.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/25.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">PRADA／2WAYバッグ／26 x20 x14cm</span>         
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/26.jpg" alt="" />
            <span className="text-center">PRADA／2WAYバッグ／25 x19 x14cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/27.jpg" alt="" />
            <span className="text-center">PRADA／2WAYバッグ／26 x20 x14cm</span> 
          </figure>
        </div>
        <Link to="https://laxus.co/app/pc/bags/prada" className="view-all-button">
          プラダのバッグを見る
        </Link>          
        <div className="text-max-width">
          <h2>パラダイム</h2>
          <p>「サフィアーノ」カーフとカーフレザーのダブルハンドルで、色合いも可愛い「パラダイム」。ショルダーをワンポイントにコーデしてみては？</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/8/28.jpg" alt="" />
        </figure> 
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/29.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/30.jpg" alt="" />
          </figure>          
        </div> 
        <span className="text-center">PRADA／2WAYバッグ／31 x23 x15cm</span>    
        <div className="text-max-width">
          <h2>ビブリオテーク</h2>
          <p>滑らかなカーフ、サフィアーノを贅沢に使った「ビブリオテーク」のトートは、飽きのこない定番バッグとして幅広いシーンに使われています。洗練されたシャープなフォルムとサイドから見ると襞のように施された、装飾が特徴的です。オシャレな方に人気な１点です。</p>
        </div>      
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/31.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/32.jpg" alt="" />
          </figure>
        </div>      
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/33.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/34.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">PRADA／ビブリオテーク／25 x19 x13cm</span>    
        <div className="text-max-width">
          <h2>ビジュー</h2>
          <p>プラダには色んなタイプのビジューやスタッズシリーズがあります。いつものコーディネートを華やかにオシャレに彩ってくれること間違いなしです。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/35.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/36.jpg" alt="" />
          </figure>
        </div>   
        <span className="text-center">PRADA／ハンドバッグ／23 x15 x9cm</span>        
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/37.jpg" alt="" />
            <span className="text-center">PRADA／サフィアーノ／17 x10 x3cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/38.jpg" alt="" />
            <span className="text-center">PRADA／カナパ／35 x23 x22.5cm</span> 
          </figure>
        </div>
        <div className="text-two-cloumn">
          <h2>かわいくまとめるなら<br className="pc"></br>やっぱりネイビー♡</h2>
          <p>クラシカルに可愛くまとめるなら、やっぱりネイビー×ブラウン。サフィアーノのハンドバッグもかわいいコーデに早変わりさせてくれる鉄板カラーの組み合わせです。</p>
        </div> 
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/39.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/8/40.jpg" alt="" />
          </figure>
        </div>   
        <span className="text-center">PRADA／サフィアーノ／30 x22 x15cm</span>                                    
        <Link to="https://laxus.co/app/pc/bags/prada" className="view-all-button">
          プラダのバッグを見る
        </Link>                                                   
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post8

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 8}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
